export interface FlowStep {
  title: string;
  icon?: string;
  description?: string;
}
